<plyca-ui-alert [typeClass]="'alert-info'" [marginClass]="'m-b-xs'">
  <div class="signature-tool__head">
    <i
      class="signature-tool__head__icon fas fa-1-5x fa-info-circle"
      aria-hidden="true"
    ></i>
    <span class="signature-tool__title">
      <strong
        *ngIf="!fileAdded"
        [innerHTML]="'SignatureTool.infoTitle' | translate"
      ></strong>
      <strong
        *ngIf="!isPdf && fileAdded"
        [innerHTML]="'SignatureTool.remember' | translate"
      ></strong>
    </span>
  </div>
  <ng-container *ngIf="!fileAdded">
    <p
      class="signature-tool__description"
      [innerHTML]="'SignatureTool.infoDescription' | translate"
    ></p>
  </ng-container>
  <ul class="signature-tool__list">
    <li
      *ngIf="!isPdf || !fileAdded"
      [innerHTML]="'SignatureTool.errorFormat' | translate"
    ></li>
  </ul>
</plyca-ui-alert>
